/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormFields } from '~/components/FormFields';
import { Grid, Tab, TabPane } from 'semantic-ui-react';
import InfoPopup from '~/components/InfoPopup';

interface SmsVerificationProps {
  messagingOptions: any
  tabIndex: number
}

const SmsVerification: React.FC<SmsVerificationProps> = (props) => {
  const { control, getValues } = useFormContext();
  const [activeIndex, setActiveIndex] = useState(0);
  const { messagingOptions } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (props.tabIndex >= 0) {
      setActiveIndex(props.tabIndex)
    }
  }, [props.tabIndex])

  function getLabel() {
    return <label style={{ display: 'flex', alignItems: 'baseline' }}>
      <div>{t('Content of SMS')}</div>
      <span style={{ color: 'red' }}>*</span>
      <InfoPopup
        content={t('Please enter the text to be displayed in the SMS in the corresponding language.')}
        styleIcon={{ marginLeft: 5, cursor: 'pointer' }}
      />
    </label>
  }

  function renderSmsContentTextArea(languageItem) {
    const languages = getValues('texts[0].languages') || []
    const indexLanguage = languages.findIndex(language => language.id === languageItem.id)
    return (
      <FormFields.TextArea
        key={languageItem.id}
        control={control}
        style={{ width: 300 }}
        name={`texts[0].languages[${indexLanguage}].translation`}
        label={getLabel()}
        rules={{
          required: {
            value: true,
            message: t('Please enter sms content')
          },
          maxLength: {
            value: 1000,
            message: t('Max amount of characters is 1000')
          }
        }}
      />
    );
  }

  const panes = messagingOptions?.languages?.map((language, index) => ({
    menuItem: messagingOptions?.languages[index]?.label || null,
    component: renderSmsContentTextArea(language)
  }));

  return (
    <>
      <Grid columns={2} stackable style={{ marginBottom: '2rem' }}>
        <Grid.Column>
          {messagingOptions?.languages.length > 0 && (
            <Tab
              menu={{ secondary: true, pointing: true }}
              activeIndex={activeIndex}
              renderActiveOnly={false}
              onTabChange={(_, data) => setActiveIndex(data.activeIndex as number)}
              panes={panes.map((pane, index) => {
                return {
                  menuItem: pane.menuItem,
                  pane: <TabPane
                    children={pane.component}
                    active={index === activeIndex}
                    style={{ border: 'none' }}
                    key={pane.menuItem}
                  />
                }
              })}
            />
          )}
        </Grid.Column>
        <Grid.Column>
          <div style={{ display: 'flex' }}>
            <FormFields.Checkbox
              control={control}
              checkboxValue={1}
              defaultValue={0}
              name='smsVerificationRegistration'
              label={t('Verify registration via SMS?')}
            />
            <InfoPopup
              content={t(
                'If you have subscribed to the SMS service, the initial authentication and password reset can be verified by the farmer user using an SMS code.'
              )}
              styleIcon={{ marginLeft: 3, cursor: 'pointer' }}
            />
          </div>
          <div style={{ display: 'flex' }}>
            <FormFields.Checkbox
              control={control}
              checkboxValue={1}
              defaultValue={0}
              name='tfaDefaultSms'
              label={t('Take over SMS as standard 2FA if mobile number is available?')}
            />
            <InfoPopup
              content={t('Should SMS authentication be used as the default verification for the farmer user?')}
              styleIcon={{ marginLeft: 3, cursor: 'pointer' }}
            />
          </div>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default SmsVerification;
